import type { BrandInfo, VagaResumo } from '../types'
import { localStr } from '../utils'
import { JobBrand } from './JobBrand'

interface JobListProps {
  lista: VagaResumo[]
  selecionada: string | null
  carregando: boolean
  brandFor: (v: VagaResumo) => BrandInfo
  onSelect: (id: string) => void
}

export function JobList({ lista, selecionada, carregando, brandFor, onSelect }: JobListProps) {
  if (carregando) {
    return <div className="cr-loading">Carregando vagas…</div>
  }
  if (!lista.length) {
    return <div className="cr-empty">Nenhuma vaga aberta no momento. Volte em breve.</div>
  }

  return (
    <>
      {lista.map((v) => {
        const brand = brandFor(v)
        const on = selecionada === v.id ? 'on' : ''
        return (
          <a
            key={v.id}
            className={`cr-job ${on}`}
            href={`#/vaga/${v.id}`}
            style={{ ['--emp-cor' as string]: brand.cor_primaria }}
            onClick={(e) => {
              e.preventDefault()
              onSelect(v.id)
            }}
          >
            <JobBrand brand={brand} />
            <h3 className="cr-job-title">{v.titulo}</h3>
            <p className="cr-job-meta">{localStr(v)}</p>
            <div className="cr-job-chips">
              <span className="cr-chip">{v.modalidade_display || v.modalidade || '—'}</span>
              {v.tipo_contrato_display && (
                <span className="cr-chip soft">{v.tipo_contrato_display}</span>
              )}
            </div>
          </a>
        )
      })}
    </>
  )
}
